import { BASE_URL } from '../../../../config/environmentConfig';
import { eligibilityActionTypes } from '../eligibility-action-types';
import * as React from 'react';
import { IEligibilityAction } from '../eligibility-interfaces';
import { MRT_PaginationState } from 'material-react-table';
import { DELETE, GET } from '../../store-helper';

export const fetchBlockList = async (
	dispatch: React.Dispatch<IEligibilityAction>,
	currentPage: number,
	pageSize: number,
	value: string
): Promise<void> => {
	try {

		dispatch({ type: eligibilityActionTypes.START_BLOCK_LIST_LOADING });

		const res = await GET({
			pathname: `${BASE_URL.ELIGIBILITY}/RiskManagement/block-list?pageNumber=${currentPage}&pageSize=${pageSize}&query=${value}`
		});

		dispatch({ type: eligibilityActionTypes.FETCH_BLOCK_LIST, payload: res?.blockList?.rows, totalItemCount: res?.blockList?.totalItemCount });
	} catch (e) {
		console.log(e);
		dispatch({ type: eligibilityActionTypes.FAILED_LOADING });
	}
};

export const deleteBlockedItem = async (id: string): Promise<void> => {
	try {
		await DELETE({ pathname: `${BASE_URL.ELIGIBILITY}/RiskManagement?Id=${id}` });
	} catch (e) {
		console.log(e);
	}
};

export const setBlockListPagination = (dispatch: React.Dispatch<IEligibilityAction>, value: MRT_PaginationState): void => {
	dispatch({
		type: eligibilityActionTypes.SET_BLOCK_LIST_TABLE_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};
